/**
 * Created by OLD on 20/08/2015.
 */
define('caccountAdminsAddView',[
  'module',
  'template!caccountAdminsAddTpl',
  'dialogFormView'
], function(
  module,
  viewTpl,
  DialogFormView
) {
  'use strict';

  var CAccountsAdminsTabPopupView = DialogFormView.extend({
    template: viewTpl,

    ui: {
      input: '.js-popup-input'
    },

    events: {
      'change @ui.input': 'onInputChange',
      'focus @ui.input': 'onFocus'
    }
  });

  module.exports = CAccountsAdminsTabPopupView;
});
